export default __webpack_public_path__ + "ad83c05af974f8206f3a0efc18f8a55b.jpg";